import { useNavigate } from 'react-router-dom';
import { Compass, Home } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';

export function NotFoundView() {
  const navigate = useNavigate();
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-8 py-12 md:py-20">
      <EmptyState
        icon={<Compass size={20} />}
        title="Off the map"
        description="That page doesn't exist. Let's get you back home."
        action={
          <Button variant="primary" onClick={() => navigate('/')}>
            <Home size={14} />
            Back to home
          </Button>
        }
      />
    </div>
  );
}
